import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";

/**
 * Single feature-flag gate for the bundle of ANC additions shipped under
 * the "ElephantOS 2.0 — ANC Phase 1" milestone (PNE-272, PNE-273, PNE-274,
 * PNE-275, PNE-277, PNE-279). Flips together when the rollout is ready.
 */
export function useElephant200AdditionsFlag(): boolean {
  const [enabled] = useFeatureFlag<boolean>(
    featureFlags.anc.elephant200Additions,
  );
  return !!enabled;
}
